import React, { useState } from 'react'
import { Fade as Hamburger } from 'hamburger-react'
import { Link, graphql, useStaticQuery } from 'gatsby'

// components
import Dropdown from './dropdown'
import Search from './search'

const Header = () => {
  const data = useStaticQuery(graphql`
    {
      prismicNavigation {
        ...PrismicNavigationFragment
      }
    }
  `)

  const [isOpen, setOpen] = useState(false)
  const headerData = data.prismicNavigation.data

  return (
    <header role='banner' className='relative z-20 w-full bg-white font-medium text-gray-700 shadow-md'>
      <nav className='relative mx-auto flex max-w-screen-2xl flex-wrap items-center justify-between px-4'>
        <div className='flex flex-1 items-center justify-between py-2'>
          <Link to='/' className={`${isOpen ? 'fixed top-5 left-5 z-50' : ''} logo w-60 py-2 focus:outline-none focus:ring lg:w-48 xl:w-96`}>
            <svg className='w-full' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 399.94 52.98'>
              <title>Parking4Less</title>
              <g id='Layer_2' data-name='Layer 2'>
                <g id='Layer_1-2' data-name='Layer 1'>
                  <path
                    className='cls-1'
                    d='M194.42,26.6A7.82,7.82,0,0,1,192.58,32a6.58,6.58,0,0,1-5.17,2.06h-4.93V44.8h-5.57V9.41l9.48-.05a8,8,0,0,1,8,8Zm-5.35-1.45V18.62a6.35,6.35,0,0,0-.64-3.48c-.57-.71-1.73-1.07-3.5-1.07h-2.45V29.6l3.32,0a2.84,2.84,0,0,0,2.73-1.34A6.81,6.81,0,0,0,189.07,25.15Z'
                  />
                  <path className='cls-1' d='M212.26,44.8h-5.55l-1.3-7.92h-4.09L200,44.8h-5.55L200.58,10l5.73.05Zm-7.72-13.49-1.12-8.46-1.13,8.46Z' />
                  <path
                    className='cls-1'
                    d='M232.82,44.8h-5.36V36.29q0-3.1-2.12-4a15.74,15.74,0,0,0-4.84-.48v13h-5.57V9.89l9.48-.05a8,8,0,0,1,8,8v6a7.22,7.22,0,0,1-1,3.43,5,5,0,0,1-2.38,2.41,6.84,6.84,0,0,1,2.57,2.15A5.4,5.4,0,0,1,232.82,35Zm-5.73-22.34V19.12a5.9,5.9,0,0,0-.8-3.6c-.53-.65-1.66-1-3.4-1H220.5V26.92l3.35,0Q227.09,27,227.09,22.46Z'
                  />
                  <path className='cls-1' d='M253.89,44.8h-6.13L240.9,34.63V44.8h-5.57V10.05h5.57V20.12l6.8-10.07h6.08L241.6,27.32Z' />
                  <path className='cls-1' d='M262.22,44.8h-5.57V10l5.57.05Z' />
                  <path className='cls-1' d='M282.46,44.8h-5.68l-5.62-18.95V44.8H266l-.16-34.75h5.69l5.76,19.42V10.05h5.15Z' />
                  <path
                    className='cls-1'
                    d='M303.18,30v7.25a8,8,0,0,1-8,8h-1.4a8.06,8.06,0,0,1-8-8V17.38a7.73,7.73,0,0,1,2.36-5.67,7.72,7.72,0,0,1,5.67-2.35h1.4a7.72,7.72,0,0,1,5.67,2.35,7.74,7.74,0,0,1,2.36,5.68V22.9h-5.36V20.67a15.25,15.25,0,0,0-.42-4.21,3,3,0,0,0-3.08-2.28q-3.24,0-3.24,4.48V35.83c0,3,1.16,4.48,3.48,4.48a2.81,2.81,0,0,0,2.89-1.65,11.19,11.19,0,0,0,.37-3.55h-3.69V30Z'
                  />
                  <path className='cls-2' d='M324.6,31.79l-.06,4.5h-2.3V44.8h-5.09V36.29H305.43l-.06-4.5L317.48,11.5h5.92l-12,20.29h5.73V26.06l5.09.06v5.67Z' />
                  <path className='cls-1' d='M342.64,39.82v5H326.42V10.05H332V39.82Z' />
                  <path className='cls-1' d='M360.1,39.82v5H343.87V10.05L360.1,10v5H349.44v9.37H360.1v5H349.44V39.82Z' />
                  <path
                    className='cls-1'
                    d='M380,19.69h-5.35a10.47,10.47,0,0,0-.48-3.71,3,3,0,0,0-3-1.8q-3.27,0-3.27,4.59a15.21,15.21,0,0,0,.43,4.28,3.05,3.05,0,0,0,3.07,2.35,8.76,8.76,0,0,1,6,2.33,7.3,7.3,0,0,1,2.6,5.64v4.38a7.7,7.7,0,0,1-2.36,5.67,7.79,7.79,0,0,1-5.69,2.35h-1.4a8.07,8.07,0,0,1-8.06-8V35.43h5.36Q367.75,41,371.29,41a2.81,2.81,0,0,0,2.78-1.5,8.07,8.07,0,0,0,.49-3.31q0-5.88-3.42-5.88a9,9,0,0,1-6.05-2.3,7.22,7.22,0,0,1-2.64-5.67V17.38a8.06,8.06,0,0,1,8.06-8h1.4a8,8,0,0,1,8,8Z'
                  />
                  <path
                    className='cls-1'
                    d='M399.94,19.69h-5.36A10.47,10.47,0,0,0,394.1,16a3,3,0,0,0-3-1.8q-3.25,0-3.26,4.59a14.84,14.84,0,0,0,.43,4.28,3,3,0,0,0,3.06,2.35,8.76,8.76,0,0,1,6,2.33,7.28,7.28,0,0,1,2.61,5.64v4.38a7.7,7.7,0,0,1-2.37,5.67,7.79,7.79,0,0,1-5.69,2.35h-1.4a8.06,8.06,0,0,1-8.05-8V35.43h5.35q0,5.52,3.48,5.52a2.83,2.83,0,0,0,2.79-1.5,8.28,8.28,0,0,0,.48-3.31q0-5.88-3.42-5.88a9,9,0,0,1-6.05-2.3,7.24,7.24,0,0,1-2.63-5.67V17.38a8,8,0,0,1,8.05-8h1.4a8.06,8.06,0,0,1,8.06,8Z'
                  />
                  <rect className='cls-3' x='2.5' y='2.5' width='48.13' height='47.98' rx='11' ry='11' />
                  <path
                    className='cls-2'
                    d='M37.09,26.34a7.9,7.9,0,0,1-1.87,5.48A6.62,6.62,0,0,1,30,33.9H25V44.7H19.42V9L29,9a7.82,7.82,0,0,1,5.73,2.37,7.85,7.85,0,0,1,2.38,5.73Zm-5.41-1.46V18.29A6.47,6.47,0,0,0,31,14.78c-.57-.72-1.75-1.08-3.53-1.08H25V29.36l3.35.06a2.87,2.87,0,0,0,2.75-1.35A7,7,0,0,0,31.68,24.88Z'
                  />
                  <path className='cls-2' d='M92.1,31.58,92,36.12H89.72V44.7H84.59V36.12H72.76l-.05-4.54,12.2-20.47h6L78.81,31.58h5.78V25.8l5.13.05v5.73Z' />
                  <path className='cls-2' d='M150.14,37.86l-17.28-8.37,0-5.78,17.23-8.16v5.62L138.29,26.6l11.85,5.62Z' />
                  <rect className='cls-3' x='60.67' y='2.5' width='48.13' height='47.98' rx='11' ry='11' />
                  <rect className='cls-3' x='118.15' y='2.5' width='48.13' height='47.98' rx='11' ry='11' />
                </g>
              </g>
            </svg>
          </Link>
          <span className={`${isOpen ? 'fixed top-3 right-4 ' : ''}z-20 order-last lg:hidden`}>
            <Hamburger color='currentColor' size={24} label='Show menu' rounded toggled={isOpen} toggle={setOpen} />
          </span>
        </div>
        <div
          className={`${
            !isOpen ? 'hidden' : 'fixed inset-0 z-10 flex h-screen flex-1 flex-col justify-start bg-gray-900 bg-opacity-25 p-2'
          } backdrop-blur-sm lg:relative lg:flex lg:h-auto lg:flex-row lg:bg-transparent`}>
          <div className='lg:max-h-none max-h-screen w-full overflow-y-scroll rounded bg-white shadow-md lg:w-auto lg:overflow-visible lg:rounded-none lg:bg-transparent lg:shadow-none'>
            <ul className='flex flex-col pt-16 lg:flex-row lg:pt-0'>
              {headerData.nav.map((nav, index) => {
                return nav.items.length === 0 ? (
                  <li key={`nav-${index}`}>
                    <Link
                      to={nav.primary.link.url}
                      className='inline-flex w-full cursor-pointer py-4 px-4 text-lg transition duration-150 ease-in-out hover:text-orange-500 focus:outline-none focus:ring sm:text-base lg:px-2 lg:pt-6'
                      activeClassName='text-orange-500'>
                      {nav.primary.label}
                    </Link>
                  </li>
                ) : (
                  <Dropdown key={`nav-${index}`} items={nav.items}>
                    {nav.primary.label}
                  </Dropdown>
                )
              })}
              <li className='flex-column order-first items-center p-4 sm:flex md:pr-0 md:pl-2 md:pb-2 lg:order-none'>
                <Search />
              </li>
            </ul>
            <p className='py-4 px-4 text-lg lg:hidden'>
              Call us free to book{' '}
              <a
                className='border-0 text-xl font-medium text-orange-500 hover:underline focus:outline-none focus:ring'
                href={`tel:${headerData.company_phone}`}
                target='_blank'
                rel='noopener noreferrer'>
                {headerData.company_phone}
              </a>
            </p>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Header
